<template>
  <hm-content title="角色管理">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="handleAdd"
          >新增</el-button
        >
        <el-button
          type="primary"
          plain
          size="small"
          @click="output(allRoleUserList, 'roleTable', '角色列表')"
          >导出</el-button
        >
        <!-- <el-button type="primary" plain size="small" @click="importExcel"
        >导入</el-button
      >-->
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="roleName"
          placeholder="请输入角色名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          class="mr10"
          v-model="createTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="创建开始日期"
          end-placeholder="创建结束日期"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>

    <div class="table">
      <el-table
        stripe
        ref="roleTable"
        :data="roleList.records"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="roleName"
          label="角色名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="roleCode"
          label="角色编码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          prop="description"
          label="备注"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="更新时间"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="授权" placement="top">
                <div
                  class="pointer mr10"
                  @click="openAuthorizeDialog(scope.row)"
                >
                  <span class="hmicon icon-xingzhuanggaizhang blue"></span>
                </div>
              </el-tooltip>
              <!-- <el-tooltip class="item" content="删除" placement="top">
                <div class="pointer mr10" @click="remove(scope.row)">
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="roleList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,  prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :title="mode === 'add' ? '新增' : '编辑'"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      width="800px"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="large-label-form"
      >
        <el-form-item label="角色名称：" prop="roleName">
          <el-input
            size="small"
            clearable
            v-model.trim="ruleForm.roleName"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色编码：" prop="roleCode">
          <el-input
            size="small"
            :disabled="mode === 'edit'"
            clearable
            v-model.trim="ruleForm.roleCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input
            size="small"
            clearable
            type="textarea"
            v-model.trim="ruleForm.description"
          ></el-input>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-drawer
      custom-class="hm-drawer"
      :wrapperClosable="false"
      title="角色权限配置"
      :visible="authorizeDialogVisible"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <div class="caption">所拥有的权限：</div>
        <el-tree
          :data="roleTreeList"
          empty-text="暂无权限"
          :props="props"
          :check-strictly="checkStrictly"
          node-key="value"
          default-expand-all
          ref="tree"
          show-checkbox
        ></el-tree>
      </div>
      <div class="drawer-footer flex flex-between item-center">
        <div>
          <el-dropdown
            @visible-change="visibleChange"
            trigger="click"
            @command="selectItem"
          >
            <span class="el-dropdown-link flex item-center">
              树操作
              <i class="el-icon-arrow-up el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="checkAll">全部勾选</el-dropdown-item>
              <el-dropdown-item command="cancleCheckAll"
                >取消全选</el-dropdown-item
              >
              <el-dropdown-item command="openAll">展开所有</el-dropdown-item>
              <el-dropdown-item command="cancleOpenAll"
                >合并所有</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-button type="primary" size="small" @click="savePermission"
            >保存</el-button
          >
          <el-button size="small" @click="authorizeDialogVisible = false"
            >返回</el-button
          >
        </div>
      </div>
    </el-drawer>
  </hm-content>
</template>

<script>
import { outPutMixin } from "@/mixins/outputMixin";
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  mixins: [outPutMixin],
  data() {
    return {
      checkStrictly: true,
      expandTree: true,
      authorizeDialogVisible: false,
      dialogFormVisible: false,
      mode: "add",
      createTime_begin: "",
      createTime_end: "",
      createTime: [],
      lastpermissionIds: "",
      currentPage: 1,
      pageSize: 10,
      roleName: "",
      isChecked: false,
      ruleForm: {
        roleName: "",
        roleCode: "",
        description: ""
      },
      currentRow: {},
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        roleCode: {
          required: true,
          message: "请输入角色编码",
          trigger: "blur"
        },
        description: {
          max: 126,
          message: "长度不超过 126 个字符",
          trigger: "blur"
        }
      },
      props: {
        label: "slotTitle",
        children: "children"
      }
    };
  },
  computed: {
    contentHeight() {
      return window.innerHeight - 59 + "px";
    },
    ...mapGetters([
      "roleList",
      "roleUserList",
      "allRoleUserList",
      "roleTreeList",
      "currentRolePermiision"
    ])
  },
  watch: {
    createTime(v) {
      if (v) {
        this.createTime_begin = v ? v[0] : "";
        this.createTime_end = v ? v[1] : "";
      }
    },
    currentRolePermiision(v) {
      this.$refs.tree.setCheckedKeys(v);
      this.lastpermissionIds = v.join(",");
    }
  },
  created() {
    this.getParamsCookie();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    savePermission() {
      const idList = this.$refs.tree.getCheckedNodes().map(v => v.value);
      this.$store
        .dispatch("saveRolePermission", {
          lastpermissionIds: this.lastpermissionIds,
          permissionIds: idList.join(","),
          roleId: this.currentRow.id,
          loginType: "store"
        })
        .then(res => {
          if (res.success) {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.authorizeDialogVisible = false;
          }
        });
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.mode = "add";
    },
    handleClose() {
      this.authorizeDialogVisible = false;
    },
    importExcel() {},
    openAuthorizeDialog(row) {
      this.currentRow = row;
      this.authorizeDialogVisible = true;
      this.$store.dispatch("queryRoleTreeList", {
        loginType: "store"
      });
      this.$store.dispatch("queryCurrentRolePermission", {
        roleId: row.id,
        loginType: "store"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        createTime_begin: this.createTime_begin,
        createTime_end: this.createTime_end,
        roleName: this.roleName,
        column: "createTime",
        order: "desc",
        loginType: "store"
      };
      this.setParamsCookie();
      const actionName = queryAll ? "queryAllRoleList" : "queryRoleList";
      return this.$store.dispatch(actionName, params);
    },
    setParamsCookie() {
      let searchCondition = {
        createTime_begin: this.createTime_begin,
        createTime_end: this.createTime_end,
        roleName: this.roleName
      };
      setCookie({
        key: "roleParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "roleParams", type: "session" });
      if (prams) {
        if (prams.createTime_begin) {
          this.createTime_begin = prams.createTime_begin;
          this.createTime_end = prams.createTime_end;
          this.createTime = [prams.createTime_begin, prams.createTime_end];
        }
        this.roleName = prams.roleName;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    edit(row) {
      this.mode = "edit";
      this.currentRow = row;
      this.dialogFormVisible = true;
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
    },
    selectItem(e) {
      let expand = false;
      switch (e) {
        case "checkAll":
          this.$refs.tree.setCheckedNodes(this.roleTreeList);
          expand = true;
          break;
        case "cancleCheckAll":
          this.$refs.tree.setCheckedNodes([]);
          expand = true;
          break;
        case "openAll":
          expand = true;
          break;
        case "cancleOpenAll":
          expand = false;
          break;
        default:
          break;
      }
      for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
        this.$refs.tree.store._getAllNodes()[i].expanded = expand;
      }
    },
    visibleChange(visible) {
      this.checkStrictly = !visible;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let actionName = "";
          let params = this[formName];
          if (formName === "ruleForm") {
            if (this.mode === "add") {
              actionName = "addRole";
            } else {
              actionName = "editRole";
              Object.assign(params, { id: this.currentRow.id });
            }
          }
          params.loginType = "store";
          this.$store.dispatch(actionName, params).then(res => {
            if (res.success) {
              this.dialogFormVisible = false;
              this.queryList();
            }
          });
        }
      });
    },
    remove(row) {
      this.$confirm(
        `删除<span style="color: red">${row.roleName}</span>?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      ).then(() => {
        this.$store
          .dispatch("deleteRole", {
            id: row.id
          })
          .then(res => {
            if (res.success) {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this[formName]) {
        this[formName][key] = "";
      }
      this.dialogFormVisible = false;
      this.drawerFormVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.el-dropdown-link {
  border: 1px solid #d9d9d9;
  height: 30px;
  padding: 0 15px;
  border-radius: 3px;
}
</style>
